import React from 'react'

export default props => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M4 13L9 18L20 7"
      stroke="white"
      stroke-width="2"
      strokeLinecap="round"
      stroke-linejoin="round"
    />
  </svg>
)
